/**
 * creates and returns a validation rule object that
 * is used by useForm hook to validate the form inputs
 *
 * @param {string} ruleName - name of the validation rule
 * @param {string} errorMessage - message to display
 * @param {function} validateFunc - validation function
 */
function createValidationRule(ruleName, errorMessage, validateFunc) {
  return {
    name: ruleName,
    message: errorMessage,
    validate: validateFunc
  };
}

export function requiredRule(inputName) {
  return createValidationRule(
    "required",
    `${inputName} required`,
    (inputValue, formObj) => inputValue.length !== 0
  );
}
export function noSpace(inputName) {
  return createValidationRule(
    "no-space",
    `${inputName} must not contain space or special character`,
    // (inputValue, formObj) => !(/\s/.test(inputValue))
    (inputValue, formObj) => (/^(\d|\w)+$/.test(inputValue))
  );
}
export function validUsernameRule(inputName) {
  return createValidationRule(
    "usernameRule",
    `${inputName} is Invalid`,
    (inputValue, formObj) => ((/^[a-z]{1}\w{3,23}[^_]$/ig.test(inputValue)))
  );
}

export function minLengthRule(inputName, minCharacters) {
  return createValidationRule(
    "minLength",
    `${inputName} should contain atleast ${minCharacters} characters`,
    (inputValue, formObj) => inputValue.length >= minCharacters
  );
}

export function maxLengthRule(inputName, maxCharacters) {
  return createValidationRule(
    "maxLength",
    `${inputName} cannot contain more than ${maxCharacters} characters`,
    (inputValue, formObj) => inputValue.length <= maxCharacters
  );
}

export function emailValidRule(inputName) {
  return createValidationRule(
    "inValidEmail",
    `${inputName} inValid emailID`,
    (inputValue, formObj) => {
      const regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        if(!inputValue || regex.test(inputValue) === false){
            return false;
        }
        return true;
    }
  );
}

export function passwordValidRule(inputName) {
  return createValidationRule(
    "inValidPaswd",
    `Please choose a strong password.\n- lest 8 characters long,\n- contain 1 lowercase character,\n- 1 uppercase character,\n- 1 number,- least on 1 special character (!@#$%^&*).`,
    (inputValue, formObj) => {
      const minMaxLength = /^[\s\S]{8,32}$/,
      upper = /[A-Z]/,
      lower = /[a-z]/,
      number = /[0-9]/,
      special = /[ !"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]/;

      if (minMaxLength.test(inputValue) &&
          upper.test(inputValue) &&
          lower.test(inputValue) &&
          number.test(inputValue) &&
          special.test(inputValue)
      ) {
          return true;
      }

      return false;
    }
  );
}